import { themeVars } from '@coverflex-tech/hypernova';
import { style } from '@vanilla-extract/css';

const wrapper = style({
  width: '100%',
  height: '100%',
});

const host = style({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const form = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.spacing.md,
  marginTop: themeVars.spacing.lg,
  marginBottom: themeVars.spacing['2xl'],
});

const actions = style({
  display: 'flex',
  alignItems: 'center',
  gap: themeVars.spacing.lg,
});

const links = style({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  gap: themeVars.spacing.md,
});

export const css = {
  wrapper,
  host,
  form,
  actions,
  links,
};
